// Mock data pour le site Paysfor

export const companyInfo = {
  name: "Paysfor",
  slogan: "Un service à la hauteur de vos arbres",
  phone: "+1 (514) 714-4245",
  email: "axel.tempobuono@gmail.com",
  location: "Québec, QC",
  serviceArea: "Capitale-Nationale",
  serviceAreaNote: "Pour les travaux forestiers et les chantiers d'envergure, des déplacements à l'extérieur de la région sont possibles selon le projet."
};

export const services = {
  residential: [
    {
      id: 'res-1',
      title: "Abattage d'arbres",
      description: "Service professionnel d'abattage sécuritaire pour tous types d'arbres, dangereux ou non. Équipement spécialisé et techniques éprouvées.",
      benefits: ["Sécurité maximale", "Nettoyage complet du site", "Respect des propriétés avoisinantes"]
    },
    {
      id: 'res-2',
      title: "Élagage et taille d'arbres",
      description: "Taille précise pour la santé et l'esthétique de vos arbres. Techniques respectueuses favorisant une croissance optimale.",
      benefits: ["Amélioration de la santé de l'arbre", "Esthétique soignée", "Prévention des risques"]
    },
    {
      id: 'res-3',
      title: "Taille de haies",
      description: "Entretien régulier et taille professionnelle de vos haies pour un aspect impeccable tout au long de l'année.",
      benefits: ["Forme harmonieuse", "Densité contrôlée", "Croissance uniforme"]
    },
    {
      id: 'res-4',
      title: "Paysagement",
      description: "Aménagement paysager complet adapté à vos besoins et à votre terrain. Du design à la réalisation.",
      benefits: ["Conception personnalisée", "Végétaux adaptés au climat québécois", "Mise en valeur de votre propriété"]
    },
    {
      id: 'res-5',
      title: "Plantation",
      description: "Plantation professionnelle d'arbres, d'arbustes et de haies pour embellir votre terrain. Incluant la plantation de haies de cèdre pour intimité et protection. Choix des essences adaptées et techniques de plantation optimales.",
      benefits: ["Sélection des bonnes essences", "Plantation de haies de cèdre", "Technique appropriée", "Conseils d'entretien"]
    },
    {
      id: 'res-6',
      title: "Dessouchage",
      description: "Extraction complète de souches d'arbres avec machinerie spécialisée. Service rapide et efficace pour libérer votre terrain.",
      benefits: ["Machinerie adaptée", "Extraction complète", "Terrain prêt pour aménagement"]
    },
    {
      id: 'res-7',
      title: "Entretien de terrains",
      description: "Service complet d'entretien pour maintenir votre terrain en parfait état toute l'année.",
      benefits: ["Entretien régulier", "Intervention rapide", "Terrain toujours impeccable"]
    },
    {
      id: 'res-8',
      title: "Débroussaillage résidentiel",
      description: "Nettoyage et dégagement de terrains envahis par la végétation. Redonner vie à votre espace extérieur.",
      benefits: ["Terrain dégagé", "Prévention des incendies", "Amélioration de l'accessibilité"]
    },
    {
      id: 'res-9',
      title: "Déboisement résidentiel",
      description: "Service de déboisement contrôlé pour préparer votre terrain à de nouveaux projets.",
      benefits: ["Travail précis", "Respect de l'environnement", "Site prêt pour aménagement"]
    }
  ],
  commercial: [
    {
      id: 'com-1',
      title: "Abattage d'arbres commercial",
      description: "Solutions professionnelles pour entreprises, municipalités et institutions. Intervention rapide et sécuritaire.",
      benefits: ["Minimisation des interruptions", "Équipe expérimentée", "Respect des échéanciers"]
    },
    {
      id: 'com-2',
      title: "Élagage et taille commercial",
      description: "Entretien d'arbres pour espaces commerciaux, parcs et zones institutionnelles.",
      benefits: ["Planification flexible", "Travail discret", "Résultats professionnels"]
    },
    {
      id: 'com-3',
      title: "Taille de haies commercial",
      description: "Entretien régulier de haies pour maintenir l'image professionnelle de votre entreprise.",
      benefits: ["Contrats d'entretien", "Service planifié", "Apparence soignée"]
    },
    {
      id: 'com-4',
      title: "Paysagement commercial",
      description: "Aménagements paysagers pour entreprises souhaitant valoriser leur espace extérieur.",
      benefits: ["Design professionnel", "Entretien facile", "Image valorisée"]
    },
    {
      id: 'com-5',
      title: "Plantation",
      description: "Plantation d'arbres, d'arbustes et de haies pour espaces commerciaux. Incluant la plantation de haies de cèdre pour délimitation et intimité. Sélection d'essences adaptées aux environnements urbains.",
      benefits: ["Choix d'essences résistantes", "Plantation de haies de cèdre", "Installation professionnelle", "Garantie de reprise"]
    },
    {
      id: 'com-6',
      title: "Dessouchage",
      description: "Extraction de souches pour terrains commerciaux et industriels. Machinerie lourde adaptée aux grands projets.",
      benefits: ["Équipement commercial", "Extraction rapide", "Grands volumes acceptés"]
    },
    {
      id: 'com-7',
      title: "Entretien de terrains commercial",
      description: "Service complet d'entretien pour propriétés commerciales et industrielles.",
      benefits: ["Forfaits personnalisés", "Équipe fiable", "Propriété toujours présentable"]
    },
    {
      id: 'com-8',
      title: "Débroussaillage et dégagement",
      description: "Dégagement de grandes surfaces pour projets commerciaux et industriels.",
      benefits: ["Équipement adapté", "Travail efficace", "Grands terrains acceptés"]
    },
    {
      id: 'com-9',
      title: "Déboisement de terrains commerciaux",
      description: "Service de déboisement pour préparation de terrains commerciaux et industriels. Respect des normes et réglementations.",
      benefits: ["Planification rigoureuse", "Équipement commercial", "Conformité garantie"]
    }
  ],
  forestry: [
    {
      id: 'for-1',
      title: "Débroussaillage forestier",
      description: "Service spécialisé de débroussaillage en milieu forestier pour entretien de sentiers, lignes électriques et zones de coupe.",
      benefits: ["Équipement forestier professionnel", "Respect du milieu naturel", "Intervention en terrain difficile"]
    },
    {
      id: 'for-2',
      title: "Déboisement",
      description: "Déboisement contrôlé pour projets forestiers, agricoles ou de développement. Respect des normes environnementales.",
      benefits: ["Planification rigoureuse", "Machinerie adaptée", "Conformité réglementaire"]
    },
    {
      id: 'for-3',
      title: "Travaux acéricoles",
      description: "Services d'entaillage et désentaillage pour érablières. Expertise en milieu acéricole québécois.",
      benefits: ["Techniques éprouvées", "Préservation des érables", "Service saisonnier"]
    },
    {
      id: 'for-4',
      title: "Élagage de plantation",
      description: "Élagage spécialisé pour plantations forestières et reboisement. Favorise une croissance optimale.",
      benefits: ["Technique forestière", "Amélioration de la qualité du bois", "Croissance dirigée"]
    },
    {
      id: 'for-5',
      title: "Création de cartes",
      description: "Cartographie forestière et territoriale pour gestion de lots boisés et planification forestière.",
      benefits: ["Évaluation du territoire", "Outils de gestion", "Planification optimisée"]
    }
  ]
};

export const aboutContent = {
  introduction: "Paysfor est une entreprise québécoise spécialisée dans les services arboricoles, paysagers et forestiers. Animés par une passion pour le travail en milieu arboré, nous offrons des solutions adaptées aux besoins résidentiels, commerciaux et forestiers dans la Capitale-Nationale.",
  mission: "Notre mission est d'offrir des services sécuritaires, durables et bien exécutés, en adaptant chaque intervention au terrain et aux besoins spécifiques de nos clients. Nous croyons que chaque projet mérite une attention professionnelle et un travail soigné.",
  expertise: [
    "Expérience terrain en abattage, élagage, paysagement et travaux forestiers",
    "Maîtrise des techniques sécuritaires et des équipements spécialisés",
    "Connaissance approfondie du milieu forestier québécois",
    "Approche respectueuse des arbres, des infrastructures et de l'environnement"
  ],
  safety: {
    title: "Sécurité et professionnalisme",
    points: [
      "La sécurité est notre priorité absolue sur tous nos chantiers",
      "Méthodes de travail encadrées et réfléchies",
      "Chantiers propres et organisés",
      "Respect rigoureux des normes et bonnes pratiques"
    ]
  },
  whyChoose: [
    "Entreprise locale qui connaît le territoire québécois",
    "Service personnalisé adapté à chaque projet",
    "Travail soigné et fiable, du début à la fin",
    "Relation de confiance avec nos clients",
    "Personnel qualifié avec formations reconnues"
  ]
};

export const gallery = [
  {
    id: 1,
    title: "Élagage professionnel",
    categories: ["elagage"],
    imageUrl: "https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/rt7jsnob_42f10c2d-52b7-4833-a9a9-e144883cb78d.jpg"
  },
  {
    id: 2,
    title: "Travaux forestiers - Déboisement",
    categories: ["forestier", "deboisement"],
    imageUrl: "https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg"
  },
  {
    id: 3,
    title: "Expertise terrain",
    categories: ["elagage"],
    imageUrl: "https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/a2pv2tmz_194eff2e-324b-48ac-9491-0bae511366a3.jpg"
  },
  {
    id: 4,
    title: "Travail en hauteur",
    categories: ["elagage"],
    imageUrl: "https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/ihonpgi4_Alex%202.jpg"
  },
  {
    id: 5,
    title: "Dessouchage",
    categories: ["dessouchage"],
    imageUrl: "https://customer-assets.emergentagent.com/job_arborist-services/artifacts/nrd092ig_57daffdd-665c-4514-971a-9b5d2f076a36.jpg"
  },
  {
    id: 6,
    title: "Abattage d'arbres",
    categories: ["abattage"],
    imageUrl: "https://customer-assets.emergentagent.com/job_arborist-services/artifacts/v7r7q29n_81f75804-7938-43ab-ad75-e270ffb00067.jpg"
  },
  {
    id: 7,
    title: "Paysagement résidentiel",
    categories: ["paysagement"],
    imageUrl: "https://customer-assets.emergentagent.com/job_arborist-services/artifacts/g9it91th_20250724_164248.jpg"
  },
  {
    id: 8,
    title: "Taille de haies",
    categories: ["taille_haies"],
    imageUrl: "https://customer-assets.emergentagent.com/job_arborist-services/artifacts/dvo8jlcx_IMG_20250731_141410%281%29.jpg"
  },
  {
    id: 9,
    title: "Taille de haies professionnelle",
    categories: ["taille_haies"],
    imageUrl: "https://customer-assets.emergentagent.com/job_arborist-services/artifacts/2l1t9hxm_Screenshot_20250212_210136_Gallery.jpg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie-Claude L.",
    rating: 5,
    comment: "Service impeccable! L'équipe est professionnelle et le travail est soigné. Je recommande sans hésitation pour tous vos besoins arboricoles."
  },
  {
    id: 2,
    name: "Jean-François D.",
    rating: 5,
    comment: "Excellent travail d'élagage sur nos grands arbres. Équipe compétente et respectueuse de notre propriété. Très satisfait du résultat!"
  },
  {
    id: 3,
    name: "Sophie M.",
    rating: 5,
    comment: "Paysfor a transformé notre terrain! Service rapide, prix compétitif et résultat au-delà de nos attentes. Merci à toute l'équipe!"
  },
  {
    id: 4,
    name: "Patrick B.",
    rating: 5,
    comment: "Professionnalisme exemplaire pour nos travaux forestiers. Communication claire et respect des échéanciers. Une entreprise de confiance!"
  }
];

export const galleryCategories = [
  { value: 'all', label: 'Tous' },
  { value: 'abattage', label: 'Abattage' },
  { value: 'elagage', label: 'Élagage' },
  { value: 'taille_haies', label: 'Taille de haies' },
  { value: 'paysagement', label: 'Paysagement' },
  { value: 'dessouchage', label: 'Dessouchage' },
  { value: 'forestier', label: 'Travaux forestiers' },
  { value: 'acericole', label: 'Acéricole' }
];

export const ownerInfo = {
  name: "Axel",
  photo: "https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/a2pv2tmz_194eff2e-324b-48ac-9491-0bae511366a3.jpg",
  bio: "Passionné par le travail arboricole et forestier, j'ai fondé Paysfor pour offrir des services de qualité supérieure aux résidents et entreprises du Québec. Avec des formations spécialisées et une expérience terrain solide, je m'engage à réaliser chaque projet avec professionnalisme et souci du détail."
};

export const serviceTypes = [
  { value: "residential", label: "Services résidentiels" },
  { value: "commercial", label: "Services commerciaux" },
  { value: "forestry", label: "Travaux forestiers" }
];

export const locations = [
  { value: "capitale-nationale", label: "Capitale-Nationale" },
  { value: "rive-sud", label: "Rive-Sud de Montréal" }
];
